export default __webpack_public_path__ + "static/media/etherium-white.3390aa01.svg";